import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import images from 'rc-images';


const Container = styled.div`
  padding: 10px 0;
  box-sizing: border-box;
  text-align: left;
`;


const Back = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;

  &::-moz-focus-inner {
    border: 0;
  }

  
  &:focus {
    outline: none;
  }

  all: initial;
  border: none;
  color: #1675b2;
  font-family: inherit !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  position: relative;
  cursor: pointer;
  background-color: transparent !important;
  margin-left: 2px !important;

  &:hover{
    color: #104e76;
  }

  &:before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-size: contain;
    background-position: center;
    background-image: url(${images.icons.leftArrow});
    background-repeat: no-repeat;
    background-color: transparent;
    width: 15px;
    height: 15px;
  }
`;

const BackText = styled.span`
  padding: 7px 6px 10px 25px;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;


const BackButton = ({ history, children }) => (
  <div>
    {
      (history.canGo(-1))
        ? (
          <Container>
            <Back tabIndex="0" onClick={history.goBack}>
              <BackText tabIndex="-1">
                {
                  children || 'Back'
                }
              </BackText>
            </Back>
          </Container>
        ) : null
    }
  </div>
);


export default withRouter(BackButton);
